// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"fd9947e6","434":"d1e9e7f2","454":"eb94b84a","906":"8aa7fd09"}[chunkId] + ".chunk.js";
};